import React from 'react';
import { Link } from 'react-router-dom';

import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { DataTable } from 'primereact/datatable';

import { useListBiddingsController } from 'src/controllers/Bidding/ListBiddingsController';

import LoadingScreen from 'src/components/LoadingScreen';
import { dateToString } from 'src/utils/dateToString';
import { ModelOfBidding } from 'src/database';
import { useData } from 'src/contexts/data';

const BiddingsList: React.FC = () => {
  const { handleBidding } = useData();
  const { getListBiddings } = useListBiddingsController();

  if (getListBiddings.loading) {
    return <LoadingScreen />
  };

  const leftBiddingToolbar = () => {
    return (
      <Link to="/biddingForm">
        <Button label="Cadastrar licitação" icon="pi pi-plus" className="p-button-success p-mr-2" />
      </Link>
    );
  };

  const actionBodyTemplate = (Bidding: ModelOfBidding) => {
    return (
      <Link to="/biddingForm" >
        <Button icon="pi pi-chevron-circle-right" iconPos="left"
          className="p-button-rounded p-button-text p-button-success "
          onClick={() => handleBidding(({...Bidding, DATALICITACAO: dateToString(Bidding.DATALICITACAO, 'br')}))}
        />
      </Link>
    );
  }

  const tableHeader = (
    <div className="table-header p-grid p-d-flex p-jc-between">
      <h5 className="p-m-0">Licitações</h5>
      {/* <span className="p-input-icon-left p-search-bar">
        <i className="pi pi-search" />
        <InputText type="search" onChange={(e: React.ChangeEvent<HTMLInputElement>) => setGlobalFilter(e.target.value)} placeholder="Buscar..." />
      </span> */}
    </div>
  );

  const HEADER_OBJETO = (rowData: ModelOfBidding) => {
    return (
      <React.Fragment>
        <span className="left-header">OBJETO</span>
        {rowData.OBJETO}
      </React.Fragment>
    );
  }
  const HEADER_MODALIDADE = (rowData: ModelOfBidding) => {
    return (
      <React.Fragment>
        <span className="left-header">MODALIDADE</span>
        {rowData.DESCRICAO_MODALIDADE}
      </React.Fragment>
    );
  }
  const HEADER_NUMEROLICITACAO = (rowData: ModelOfBidding) => {
    return (
      <React.Fragment>
        <span className="left-header">NÚMERO LICITAÇÃO</span>
        {rowData.NUMEROLICITACAO}
      </React.Fragment>
    );
  }
  const HEADER_NUMEROPROCESSOADM = (rowData: ModelOfBidding) => {
    return (
      <React.Fragment>
        <span className="left-header">NÚMERO PROCESSO ADM</span>
        {rowData.NUMEROPROCESSOADM}
      </React.Fragment>
    );
  }
  const HEADER_DATALICITACAO = (rowData: ModelOfBidding) => {
    return (
      <React.Fragment>
        <span className="left-header">DATA LICITAÇÃO</span>
        {dateToString(rowData.DATALICITACAO, 'br')}
      </React.Fragment>
    );
  }
  const HEADER_VALORGLOBAL = (rowData: ModelOfBidding) => {
    return (
      <React.Fragment>
        <span className="left-header">VALOR GLOBAL</span>
        {Intl.NumberFormat('pt-BR', {
          style: 'currency', currency: 'BRL'
        }).format(rowData?.VALORGLOBAL || 0)}
      </React.Fragment>
    );
  }
  const HEADER_TOTALCONTRATADO = (rowData: ModelOfBidding) => {
    return (
      <React.Fragment>
        <span className="left-header">TOTAL CONTRATADO</span>
        {Intl.NumberFormat('pt-BR', {
          style: 'currency', currency: 'BRL'
        }).format(rowData?.TOTALCONTRATADO || 0)}
      </React.Fragment>
    );
  }

  return (
    <div>
      <Toast />
      <div className="p-card p-p-4 datatable-container">
        <Toolbar className="p-mb-4" left={leftBiddingToolbar}></Toolbar>

        <DataTable dataKey="ID"
          value={getListBiddings.biddingsData}
          header={tableHeader} rowHover
          autoLayout
          className="responsive-table p-datatable-sm"
          scrollable scrollHeight='100%' expandedRows={['OBJETO']}
        >
          <Column field="OBJETO" header="OBJETO" body={HEADER_OBJETO}></Column>
          <Column field="MODALIDADE" header="MODALIDADE" body={HEADER_MODALIDADE}></Column>
          <Column field="NUMEROLICITACAO" header="NÚMERO da LICITAÇÃO" body={HEADER_NUMEROLICITACAO}></Column>
          <Column field="NUMEROPROCESSOADM" header="NÚMERO PROCESSO ADM" body={HEADER_NUMEROPROCESSOADM}></Column>
          <Column field="DATALICITACAO" header="DATA LICITAÇÃO" body={HEADER_DATALICITACAO}></Column>
          <Column field="VALORGLOBAL" header="VALOR GLOBAL" body={HEADER_VALORGLOBAL}></Column>
          <Column field="TOTALCONTRATADO" header="TOTAL CONTRATADO" body={HEADER_TOTALCONTRATADO}></Column>
          <Column header="DETALHES" headerStyle={{ textAlign: 'right' }} body={actionBodyTemplate} bodyStyle={{ textAlign: 'right' }}></Column>
        </DataTable>
      </div>
    </div>
  );
}

export default BiddingsList;
